import React from "react";
import styles from "./PanelSeparator.module.scss";

const PanelSeparator = () => (
  <div className={styles.line}>
    <div className={styles.triangle} />
  </div>
);

export default PanelSeparator;
